import script from "./Infobox.vue?vue&type=script&setup=true&lang=ts"
export * from "./Infobox.vue?vue&type=script&setup=true&lang=ts"

import "./Infobox.vue?vue&type=style&index=0&id=30a7683c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30a7683c"]])

export default __exports__